// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"Templates_stickyHeader__6xs_g","gridSide":"Templates_gridSide__VYxqY"};